import { useContext, useMemo } from 'react'
import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { AdressNavigation } from '../../../StateManagment/AdressNavigation'
import { TYPE_LABELS, OUTCOME_LABELS } from '../contactMoments/contactMomentLabels'
import { FAILED_OUTCOMES } from '../../../helpers/contactMoments/computeFailedStreak'

const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' }

const outcomeChipClass = (outcome) => {
    if (outcome === 'reached') return 'contact-moment-chip contact-moment-chip-reached'
    if (FAILED_OUTCOMES.includes(outcome)) return 'contact-moment-chip contact-moment-chip-failed'
    if (outcome === 'moved') return 'contact-moment-chip contact-moment-chip-moved'
    return 'contact-moment-chip contact-moment-chip-other'
}

const RecentContactMomentsCard = () => {
    const adressId = Location()[3]
    const [, setAdressNavigation] = useContext(AdressNavigation)

    const contactMoments = useFirestoreGeneralOrderBy(
        'ContactMoments',
        'AdressID',
        adressId || '',
        'Timestamp',
        'desc'
    )

    const recent = useMemo(
        () => (Array.isArray(contactMoments) ? contactMoments.slice(0, 3) : []),
        [contactMoments]
    )

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Contactmomenten</h3>
                {recent.length === 0 ? (
                    <p className="adress-dashboard-empty">Geen contactmomenten geregistreerd.</p>
                ) : (
                    <ul className="adress-dashboard-list">
                        {recent.map(cm => (
                            <li key={cm.ID} className="adress-dashboard-list-row">
                                <div className="adress-dashboard-cm-row">
                                    <span className={outcomeChipClass(cm.Outcome)}>
                                        {OUTCOME_LABELS[cm.Outcome] || cm.Outcome}
                                    </span>
                                    <span className="adress-dashboard-list-meta">
                                        {TYPE_LABELS[cm.Type] || cm.Type}
                                        {' · '}
                                        {cm.Timestamp
                                            ? cm.Timestamp.toDate().toLocaleDateString('nl-NL', dateOptions)
                                            : ''}
                                    </span>
                                </div>
                                {cm.Body && (
                                    <span className="adress-dashboard-list-body">
                                        {cm.Body.length > 60 ? cm.Body.slice(0, 60) + '…' : cm.Body}
                                    </span>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setAdressNavigation('contactMoments')}
                >
                    Bekijk alle contactmomenten →
                </button>
            </div>
        </div>
    )
}

export default RecentContactMomentsCard
